// @ts-nocheck
/**
 * Simple Scroll Animation Handler
 * Handles fade-in animations for sections when they come into view
 */

class ScrollAnimation {
  constructor() {
    this.elements = [];
    this.observer = null;
    this.init();
  }

  init() {
    this.elements = document.querySelectorAll('.scroll-animation');
    
    if (this.elements.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
      this.elements.forEach(element => {
        element.classList.add('animate-in');
      });
      return;
    }

    this.setupIntersectionObserver();
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.3
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          this.observer.unobserve(entry.target);
        }
      });
    }, options);

    this.elements.forEach(element => {
      this.observer.observe(element);
    });
  }

  animateElement(element) {
    if (element && element.classList.contains('scroll-animation')) {
      element.classList.add('animate-in');
    }
  }

  resetElement(element) {
    if (element && element.classList.contains('scroll-animation')) {
      const originalTransition = element.style.transition;
      element.style.transition = 'none';
      
      element.classList.remove('animate-in');
      
      element.offsetHeight;
      
      requestAnimationFrame(() => {
        element.style.transition = originalTransition;
      });
    }
  }

  resetAllElements() {
    this.elements.forEach(element => {
      this.resetElement(element);
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.elements = [];
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.scrollAnimation = new ScrollAnimation();
});

document.addEventListener('shopify:section:load', () => {
  if (window.scrollAnimation) {
    window.scrollAnimation.destroy();
  }
  window.scrollAnimation = new ScrollAnimation();
});
